import React, { useState, useEffect } from "react";

import Locationimg from '../../Components/images/contact-icon-1.png';
import Emailimg from "../../Components/images/contact-icon-2.png";
import Telephoneimg from "../../Components/images/contact-icon-3.png";
import Rceptionimg from "../../Components/images/contact-icon-4.png";
import Title from "../../Components/images/title.png";
import ReCAPTCHA from "react-google-recaptcha";
import { api } from "../Costants";
import Breadcrumb from "../Breadcrumb/Breadcrumb";

function Contacttwoss() {
  const [userst, setUsers] = useState({});
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");

  const details_fetch = async () => {
    try {
      const response = await fetch(api + "company_profile_list", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (data.records?.[0]) {
        setUsers(data.records[0]);
      }
    } catch (error) {
      console.error("Company details fetch failed", error);
    }
  };

  useEffect(() => {
    details_fetch();
  }, []);

  const handleFormSubmit = (ev) => {
    ev.preventDefault();

    const nameValid = /^[a-zA-Z ]{2,30}$/.test(name.trim());
    const mobileValid = /^\d{10}$/.test(mobile.trim());
    const emailValid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email.trim());

    document.getElementById("nameerror").innerHTML = name === ''
      ? "Name is Required" : nameValid ? "" : "Enter a valid name";

    document.getElementById("numbererror").innerHTML = mobile === ''
      ? "Valid Mobile No is Required" : mobileValid ? "" : "Enter a Valid Mobile No";

    document.getElementById("emailrerror").innerHTML = email === ''
      ? "Email Address is Required" : emailValid ? "" : "Enter a Valid Email Address";

    document.getElementById("subjecterror").innerHTML = subject === ''
      ? "Subject is Required" : "";

    document.getElementById("messageerror").innerHTML = message === ''
      ? "Message is Required" : "";

    if (!nameValid || !mobileValid || !emailValid || !subject || !message) {
      return;
    }

    const dataTosubmit = {
      name,
      email,
      mobile,
      subject,
      message,
      token: captchaToken, // if backend needs CAPTCHA verification
    };

 const formData = new URLSearchParams();
formData.append("name", name);
formData.append("email", email);
formData.append("mobile", mobile);
formData.append("subject", subject);
formData.append("message", message);
// If backend expects CAPTCHA:
if (captchaToken) formData.append("token", captchaToken);

fetch('https://sriraghavendradecorators.com/Admin/Apidata/contact', {
  method: "POST",
  headers: {
    "Content-Type": "application/x-www-form-urlencoded"
  },
  body: formData.toString()
})

      .then((res) => res.json())
      .then((res) => {
        if (res.status === 200) {
          alert("Contact Message Sent Successfully.");
          setName("");
          setMobile("");
          setEmail("");
          setSubject("");
          setMessage("");
        } else {
          alert("Some error occurred: " + res.msg);
        }
      })
      .catch(() => {
        alert("Failed to send message. Please try again.");
      });
  };

  const handleKeyPress = (e) => {
    const key = e.key;
    const regex = /[0-9]/;
    if (!regex.test(key)) {
      e.preventDefault();
    }
  };

  const onInputChange = (e) => {
    const { value } = e.target;
    const re = /^[A-Za-z ]*$/;
    if (value === "" || re.test(value)) {
      setName(value);
    }
  };

  const handleCaptchaChange = (value) => {
    setCaptchaToken(value);
  };

  return (
    <div>
      <Breadcrumb mainheading="CONTACT US" title_one="Contact Us" />
      <div className="contact-article-2 pt-50 pb-50">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-10">
              <div className="section-title text-center pb-20">
                <h3>You are Welcome</h3>
                <img className="small-size-title-image" src={Title} alt="title" />
              </div>
              <p>
                Thanks for Showing interest in our projects. Feel free to contact us—we’ll respond as soon as possible.
              </p>
            </div>
          </div>
          <div className="row pt-25">
            <div className="col-md-4 pb-25">
              <div className="contact-ar2-left">
                <h5>Quick Contact</h5>
                <p>If you have any questions, use the details below.</p>
                <div className="contact-ar2-left-inner pt-20">
                  <figure>
                    <img src={Locationimg} alt="location" />
                    <figcaption>
                      <h6>Address :</h6>
                      <p>
                        {/* <a href="https://www.google.com/maps" target="_blank" rel="noreferrer">
                          {userst.address1}<br />
                          {userst.address2}-{userst.pincode}
                        </a> */}

                           <a href="https://www.google.com/maps/place/Sri+Raghavendra+Decors/@11.08266,77.0305798,1031m/data=!3m2!1e3!4b1!4m6!3m5!1s0x3ba859d676db5273:0x76f0fd7cd668167a!8m2!3d11.0826547!4d77.0331547!16s%2Fg%2F1q6nz9r4k?entry=ttu&g_ep=EgoyMDI1MTAwNC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noreferrer">
                          No.127, Chandra Garden,
Kattor Street, Kalapatti, Coimbatore,
Tamil Nadu 641048
                        </a>
                      </p>
                    </figcaption>
                  </figure>
                  <figure>
                    <img src={Emailimg} alt="email" />
                    <figcaption>
                      <h6>Email Us :</h6>
                      <a href={`mailto:${userst.email}`}>
                        <p>{userst.email}</p>
                      </a>
                    </figcaption>
                  </figure>
                  <figure>
                    <img src={Telephoneimg} alt="phone" />
                    <figcaption>
                      <h6>Call Us :</h6>
                      <div className="d-flex flex-column">
                        


                        {/* <a href={`tel:+91${userst.mobile}`}><p>+91 {userst.mobile}</p></a>
                        <a href="tel:+919894090587"><p>+91 9894090587</p></a> */}

                          <a href={`tel:+91 9894090587`}><p>+91 98940 90587</p></a>
                        <a href="tel:+91 9597190587"><p>+91 95971 90587</p></a>
                      </div>
                    </figcaption>
                  </figure>
                  <figure>
                    <img src={Rceptionimg} alt="reception" />
                    <figcaption>
                      <h6>Reception :</h6>
                      <p>09.00am to 06.00pm</p>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>

            <div className="col-md-8 pb-25">
              <div className="contact-ar2-right">
                <h5>Get in Touch</h5>
                <p className="pb-3">Our support team is ready 24/7.</p>
                <form method="POST" onSubmit={handleFormSubmit} autoComplete="off">
                  <div className="row mb-3 g-3">
                    <div className="col-lg-6">
                      <input type="text" className="form-control" placeholder="Your Name"
                        name="name" id="name" value={name} onChange={onInputChange} required />
                      <small id="nameerror" className="error"></small>
                    </div>
                    <div className="col-lg-6">
                      <input type="text" className="form-control" placeholder="Phone Number"
                        name="mobile" id="mobile" value={mobile} maxLength="10"
                        onKeyPress={handleKeyPress} onChange={(e) => setMobile(e.target.value)} required />
                      <small id="numbererror" className="error"></small>
                    </div>
                    <div className="col-lg-6">
                      <input type="email" className="form-control" placeholder="Email Address"
                        name="email" id="email" value={email}
                        onChange={(e) => setEmail(e.target.value)} required />
                      <small id="emailrerror" className="error"></small>
                    </div>
                    <div className="col-lg-6">
                      <input type="text" className="form-control" placeholder="Subject"
                        name="subject" id="subject" value={subject}
                        onChange={(e) => setSubject(e.target.value)} required />
                      <small id="subjecterror" className="error"></small>
                    </div>
                    <div className="col-lg-12">
                      <textarea className="form-control" name="message" id="message"
                        value={message} placeholder="Enter your message"
                        onChange={(e) => setMessage(e.target.value)} required />
                      <small id="messageerror" className="error"></small>
                    </div>
                    <div className="col-lg-12">
                      <ReCAPTCHA
                        sitekey="6LfNIEUoAAAAAOuDPkDs0rjCOS0NNPk039LTWYLv"
                        onChange={handleCaptchaChange}
                      />
                    </div>
                    <div className="col-lg-12 mt-3">
                      <button type="submit" className="btn style1">SEND MESSAGE</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
<div className="row pt-25">
  <div className="col-md-12">
    <div className="map-container">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d29779.477265077825!2d76.95498920265996!3d11.023223261566269!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sNo.%E2%80%AF127%2C%20Chandra%20Garden%2C%20%20%20Kurumbapalayam%20Main%20Road%2C%20Kalapatti%2C%20%20%20Coimbatore%E2%80%91641048!5e1!3m2!1sen!2sin!4v1753944603923!5m2!1sen!2sin"
        width="100%"
        height="500"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Chandra Garden Location"
      />
    </div>
  </div>
</div>

        </div>
      </div>
    </div>
  );
}

export default Contacttwoss;
